export default __webpack_public_path__ + "static/media/illustration-2.683bdc1a.svg";